module.exports = __webpack_public_path__ + "static/media/Oval.a1d4bf71.png";